export default function NotFoundPage() {
  return (
    <div className="App-block">
      <h2>404 – Sivua ei löydy</h2>
      <p>Hakemaasi sivua ei löytynyt. Tarkista osoite tai palaa etusivulle.</p>
      <p>
        <a href="/">Siirry etusivulle</a>
      </p>
    </div>
  );
}

